export default "__VITE_ASSET__BG6n33Af__"